<template>
  <div class="owePayment_wrapper">
    <!-- 欠费补缴页面 -->

    <!-- 顶部栏 -->
    <van-nav-bar
      title="欠费补缴"
      @click-left="$utils.goBack()"
      @click-right="onSelectAll"
    >
      <template #left>
        <span class="icon-left"></span>
      </template>
      <template #right>
        <span v-if="isSelectAll" class="nav_text">全选</span>
        <span v-else class="nav_text">取消</span>
      </template>
    </van-nav-bar>

    <div class="owePayment_list">
      <list-view
        :list="notesList"
        :isRefresh="isRefresh"
        :isLoadMore="isLoadMore"
        :isNoMore="isNoMore"
        :isErr="isErr"
        :isAutoLoadMore="isAutoLoadMore"
        @onLoadMore="onListLoadMore"
        @onRefresh="onListRefresh"
      >
        <!-- 订单列表 -->
        <template slot="item">
          <div class="notes_list">
            <li
              class="notes_item"
              v-for="(item, index) in notesList"
              :key="index"
            >
              <div
                class="item_content"
                @click="onClickItem(item.orderStatus, item.id)"
              >
                <div class="item_top">
                  <div class="item_car">
                    <span class="car_license">{{ item.plateNumber }}</span>
                  </div>
                  <div class="item_cost">{{ (item.payableAmount - item.payAmount).toFixed(2) }}元</div>
                </div>
                <div class="item_middle">
                  <span class="car_pid">{{ item.parkingNumber }}</span>
                </div>
                <div class="item_bottom">
                  <div class="item_duration">
                    {{ item.stayTime | timeTransformation }}
                  </div>
                  <div class="item_time">{{ item.leaveTime }}</div>
                </div>
              </div>

              <div class="item_checkbox">
                <van-checkbox v-model="item.checked" shape="square" />
              </div>
            </li>
          </div>
        </template>
      </list-view>
    </div>

    <!-- <div class="owePayment_btn">
      <span>全部补缴</span>
    </div> -->

    <div class="recovery_bar">
      <div class="recovery_total">
        共 <span>{{ totalList.length }}</span> 张订单
      </div>
      <div class="recovery_total">
        合计：<span>{{ totalCost }}</span> 元
      </div>
      <div
        :class="{ disabled: totalList.length < 1 }"
        class="recovery_btn btn"
        @click="onShowQRCode"
      >
        补 缴
      </div>
    </div>

    <div v-if="isPaying" class="paying_mask">
      <!-- 支付中展示页面 -->
      <div class="payLoading">
        <span>支付中</span>
        <span class="point point1_animation"></span>
        <span class="point point2_animation"></span>
        <span class="point point3_animation"></span>
      </div>
    </div>

    <!-- 二维码页面 -->
    <transition tag="div" name="pop">
      <qr-code
        v-show="showQRCode"
        @closeQRCode="closeQRCode"
        @failCallback="failCallback"
        @successCallback="successCallback"
        @onPay="recovery"
        :showQRCode="showQRCode"
        :orderParkingId="orderParkingIdStr"
        :qrCodeInterFace="qrCodeInterFace"
        :stationId="stationId"
      ></qr-code>
    </transition>
  </div>
</template>

<script>
import scanPayMixin from "../../utils/scanPayMixin";
import listView from "../../components/ListView";
import qrCode from "../../components/QRCode";
import {
  ORDER_STATUS_ARREARS,
  ORDER_PARKING_RECOVERY_SCANCODE_PAY,
  ORDER_PARKING_RECOVERY_QRCODE,
  ORDER_PARKING_ARREARS_ORDER_PARKING_LIST,
} from "../../config/config";
import JsBridge from "../../utils/JSBridge/JsBridge";
import { Toast } from "vant";
export default {
  name: "owePayment",

  mixins: [scanPayMixin],

  components: {
    listView,
    qrCode,
  },
  data: () => ({
    isRefresh: false, //刷新
    isLoadMore: false, //加载
    isNoMore: false, //加载完毕
    isErr: false, //报错
    notesList: [], //订单列表
    isAutoLoadMore: true, //自动加载
    lastId: "", //最后一条订单的id
    plateNumber: "", //车牌号码
    qrCodeInterFace: "",
    isScanning: false,
    showQRCode: false,
    isPaying: false,
    count: 0,
    paymentNoteId: "",
    orderStatus: ORDER_STATUS_ARREARS,
    isRecovery: true,
  }),
  methods: {
    //全选
    onSelectAll() {
      if (this.isSelectAll) {
        this.notesList.forEach((item) => {
          item.checked = true;
        });
      } else {
        this.notesList.forEach((item) => {
          item.checked = false;
        });
      }
    },

    //补缴
    recovery(id) {
      if (this.totalList.length > 0) {
        this.onPay(id);
      }
    },

    //刷新请求封装
    requestRefreash() {
      //清空lastId
      this.lastId = "";

      //请求数据
      this.$request(
        ORDER_PARKING_ARREARS_ORDER_PARKING_LIST,
        {
          lastId: this.lastId,
          orderStatus: this.orderStatus,
          value: this.plateNumber,
        },
        (res) => {
          if (res["data"]["orderParkingList"]) {
            let data = res["data"]["orderParkingList"];
            //判断是否有数据
            if (data.length > 0) {
              //赋值，刷新页面
              this.lastId = data[data.length - 1]["id"];
              this.notesList = data;
              this.notesList.forEach((item) => {
                this.$set(item, "checked", false);
              });
              this.isRefresh = false;
              this.isLoadMore = false;
            } else {
              this.isNoMore = true;
              this.isRefresh = false;
            }
          } else {
            Toast("数据请求失败，请重试");
          }
        }
      );
    },

    //列表刷新
    onListRefresh() {
      this.isRefresh = true;
      this.lastId = "";
      this.isNoMore = false ;

      //防抖
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => {
        this.requestRefreash();
      }, 500);
    },

    //列表加载
    onListLoadMore() {
      this.isLoadMore = true;

      //防抖
      clearTimeout(this.loadTimer);
      this.loadTimer = setTimeout(() => {
        //请求数据
        this.$request(
          ORDER_PARKING_ARREARS_ORDER_PARKING_LIST,
          {
            lastId: this.lastId,
            orderStatus: this.orderStatus,
            value: this.plateNumber,
          },
          (res) => {
            if (res["data"]["orderParkingList"]) {
              let data = res["data"]["orderParkingList"];
              if (data.length > 0) {
                //记录数据，赋值
                this.isLoadMore = false;
                this.lastId = data[data.length - 1]["id"];
                data.forEach((item) => {
                  this.$set(item, "checked", false);
                  this.notesList.push(item);
                });
              } else {
                this.isNoMore = true;
              }
            } else {
              Toast("数据请求失败，请重试");
            }
          }
        );
      }, 500);
    },

    //点击列表
    onClickItem(orderStatus, oid) {
      if (orderStatus && oid) {
        this.$router.push({ name: "Order", params: { orderStatus, oid } });
      }
    },

    //二维码失败回调
    failCallback() {
      this.$router.replace({
        name: "Result",
        params: {
          orderStatus: this.orderStatus,
          oid: this.orderParkingIdStr,
          orderAmount: this.totalCost,
          isRecovery: this.isRecovery,
        },
      });
    },

    successCallback() {
      this.$utils.goBack();
      this.$utils.orderParkingId(this.orderParkingId);
    },

    closeQRCode() {
      this.isFirst = false;

      this.showQRCode = false;
    },

    onShowQRCode() {
      if (this.totalList.length < 1) {
        Toast.fail("请选择订单");  
      } else {
        this.qrCodeInterFace = ORDER_PARKING_RECOVERY_QRCODE;
        this.showQRCode = true;
      }
    },
  },

  computed: {
    isSelectAll() {
      if (this.notesList.filter((item) => !item.checked).length !== 0) {
        return true;
      }

      return false;
    },

    orderParkingIdStr() {
      if (this.totalList.length > 0) {
        let list = [];
        this.totalList.forEach((item) => {
          list.push(item.id);
        });
        let str = list.join(",");

        return str;
      }

      return "";
    },

    totalList() {
      if (Array.isArray(this.notesList)) {
        return this.notesList.filter((item) => item.checked);
      }
      return [];
    },

    totalCost() {
      let cost = 0;

      this.totalList.forEach((item) => {
        if (item.payableAmount) {
          cost += Number(item.payableAmount) - Number(item.payAmount);
        }
      });

      return cost.toFixed(2);
    },
  },

  watch: {
    totalCost(newV) {
      this.orderAmount = newV;
    },

    orderParkingIdStr(newV) {
      this.orderParkingId = newV;
    },
  },

  mounted() {
    JsBridge.registerHandler("showQRCode", () => {
      this.onShowQRCode();
    });
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      //改变顶部状态栏
      vm.$utils.changeStatusBarStyle("black");
      let { plateNumber } = vm.$route.params;
      if (plateNumber) {
        vm.plateNumber = plateNumber;
      }

      vm.$utils.getStationId((stationId) => {
        vm.stationId = stationId;
      });

      vm.scanCodeInterface = ORDER_PARKING_RECOVERY_SCANCODE_PAY;
    });
  },
};
</script>

<style lang="less" scoped>
.pop-enter-to,
.pop-leave {
  transform: translateY(0);
  opacity: 1;
}
.pop-enter,
.pop-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
.pop-enter-active,
.pop-leave-active {
  transition: all 0.3s;
}
.owePayment_wrapper {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  position: absolute;
  padding-top: 26px;
  top: 0;
  left: 0;
  z-index: 50;

  .icon-left {
    font-size: 20px;
    margin-right: 6px;
    color: #333;
  }

  .nav_text {
    font-size: 20px;
    color: #2b5fe6;
  }

  /deep/ .van-nav-bar__title {
    font-size: 20px;
  }
}
.notes_list {
  width: 100%;
  padding: 0 20px;
}
.owePayment_list {
  position: absolute;
  top: 65px;
  bottom: 60px;
  width: 100%;
  overflow: hidden;
}

.notes_item {
  width: 100%;
  min-height: 120px;
  display: flex;
  // justify-content: space-between;
  font-size: 14px;
  padding: 10px 0;
  border-bottom: 1px solid rgba(7, 17, 27, 0.1);

  .item_content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .item_top {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .item_car {
        font-size: 16px;
        margin-bottom: 6px;
        display: flex;
        align-items: center;

        .car_license {
          color: #666;
          font-weight: 700;
          font-size: 20px;
          margin-right: 14px;
        }
      }

      .item_cost {
        color: red;
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 6px;
      }
    }

    .car_pid {
      display: inline-block;
      width: 280px;
      vertical-align: baseline;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 18px;
    }

    .item_bottom {
      /*flex : 0 0 40px ;*/
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;

      .item_duration {
        color: rgb(129, 129, 129);
        white-space: nowrap;
        flex : 1;
      }

      .item_time {
        color: rgb(129, 129, 129);
        white-space: nowrap;
      }
    }
  }

  .item_checkbox {
    flex: 0 0 36px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

.owePayment_btn {
  padding: 0 20px;
  position: absolute;
  bottom: 10px;
  height: 40px;
  width: 100%;
  text-align: center;
  line-height: 40px;

  > span {
    display: block;
    width: 100%;
    height: 100%;
    background-color: #0263ee;
    font-size: 16px;
    color: #fff;
    border-radius: 6px;
  }
}

.recovery_bar {
  height: 60px;
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #0b0b0b;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;

  .recovery_total {
    color: #8c8c8c;
    font-size: 16px;

    span {
      color: #ec132d;
      font-size: 20px;
    }
  }

  .recovery_btn {
    width: 80px;
    height: 36px;
    background-color: #2b5fe6;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 20px;

    &.disabled {
      background-color: #666;
    }

    &.unclick {
      pointer-events: none;
    }
  }
}

.paying_mask {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 52;
  background-color: rgba(7, 17, 27, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;

  .payLoading {
    margin: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    color: skyblue;

    .point {
      display: block;
      width: 10px;
      height: 10px;
      // border : 1PX solid #333 ;
      border-radius: 50%;
      margin-left: 10px;
    }

    .point1_animation {
      animation: point1 1s linear 0ms infinite;
    }

    .point2_animation {
      animation: point2 1s linear 0ms infinite;
    }

    .point3_animation {
      animation: point3 1s linear 0ms infinite;
    }

    @keyframes point1 {
      0% {
        background-color: #fff;
      }

      50% {
        background-color: skyblue;
      }

      100% {
        background-color: skyblue;
      }
    }

    @keyframes point2 {
      0% {
        background-color: skyblue;
      }

      50% {
        background-color: #fff;
      }

      100% {
        background-color: skyblue;
      }
    }

    @keyframes point3 {
      0% {
        background-color: skyblue;
      }

      50% {
        background-color: skyblue;
      }

      100% {
        background-color: #fff;
      }
    }
  }
}
</style>
